import { makeStyles } from "@material-ui/core/styles";
import { MYCOLORS } from "../../mypallette";

export const useIntroStyles = makeStyles({
  cardmainLight: {
    minWidth: 275,
    marginTop: 15,
    backgroundSize: "cover", //contain, cover, 80%, 200px 100px
    background: MYCOLORS.lcard,
    //background: `linear-gradient(0.25turn, ${MYCOLORS.lcard}, ${MYCOLORS.lcard})`,
    // backgroundColor: "#000000",
    //backgroundImage: `url(${cardpaperLight})`,
    //backgroundRepeat: "no-repeat"
  },
  cardmainDark: {
    minWidth: 275,
    marginTop: 15,
    backgroundSize: "cover",
    background: MYCOLORS.dcard,
    //background: `linear-gradient(0.25turn, ${MYCOLORS.dcard}, ${MYCOLORS.dcard})`,
  },
  titleDark:{
    color: MYCOLORS.dtitletext,
  },
  titleLight:{
    color: MYCOLORS.ltitletext,
  },

  container: {
    //to push space down for the right hand side texts
    width: "100%",
    height: 150,
  },
});
